/**
 * Returns true if a DOM event targeted a copy button (or its child SVG).
 * Use in AG Grid onRowClicked to skip selection/navigation for copy clicks.
 */
export function isCopyButtonClick(event: { event?: Event | null }): boolean {
  const target = event.event?.target;
  if (!(target instanceof Element)) return false;
  return !!target.closest('.copy-button-cell-btn');
}
